interface NumberOptions {
  locale: string;
}

export const formatNumber = (number: number, options: NumberOptions): string =>
  new Intl.NumberFormat(options.locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(number);
